<div class="flex flex-col">
  <div class="mx-auto w-[80%]">
    <h2 class="mb-4 mt-10 text-3xl">Códigos de Artículos para Gastos</h2>
  </div>
  <ag-grid-angular
    class="ag-theme-quartz mx-auto"
    [gridOptions]="gridOptions"
    [rowData]="gastosCodigosArticulos"
    [columnDefs]="columnDefs"
  />
</div>
